import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['threshold', 'thresholdInput', 'minThresholdContainer'];
  static values = { minThreshold: Number }

  toggleThresholdInput(event) {
    this.thresholdTarget.hidden = !event.target.checked;
  }

  displayThresholdWarning(event) {
    const newThreshold = Number(event.target.value)
    if(newThreshold < this.minThresholdValue && this.minThresholdValue > 0 && newThreshold !== 0) {
      this.minThresholdContainerTarget.classList.remove('d-none')
    } else {
      this.minThresholdContainerTarget.classList.add('d-none')
    }
  }
}
